/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Alarms_Deletedat1Inputs */



/**
* | output |
* | --- |
* | "Deleted on {date}" |
*
* @param {Alarms_Deletedat1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_deletedat1 = /** @type {((inputs: Alarms_Deletedat1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Deletedat1Inputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Deleted on ${i?.date}`)
	return /** @type {LocalizedString} */ (`Supprimé le ${i?.date}`)
});
export { alarms_deletedat1 as "alarms_deletedAt" }